import axios from 'axios';
import store from '@/store/store';
import config from '@/api/config/config';

const HTTP = axios.create();

// Add a request interceptor
HTTP.interceptors.request.use((request) => {
  request.headers = {
    'Content-Type': 'application/json',
  };
  const hash = store.getters['recommandation/hash'];
  if (hash) {
    request.params = { ...request.params, hash };
  }
  if (request.url.indexOf('http') === -1) {
    // Do something before request is sent
    request.url = config.BASE_URL_GESCOM + request.url;
  }
  return request;
}, (error) => {
  // Do something with request error
  return Promise.reject(error);
});

export default HTTP;
